import { render, staticRenderFns } from "./comments-dialog.vue?vue&type=template&id=96f2a1ee&scoped=true"
import script from "./comments-dialog.vue?vue&type=script&lang=js"
export * from "./comments-dialog.vue?vue&type=script&lang=js"
import style0 from "./comments-dialog.vue?vue&type=style&index=0&id=96f2a1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f2a1ee",
  null
  
)

export default component.exports